<template>
    <labs-list renderless v-bind="$attrs">
        <template #default="{ userLabs, getEquipments, getForWho }">
            <div class="catalog-labs-slider">
                <div :class="`catalog-labs-slider__inner ${ catalogLoading ? 'loader loader--dark': '' }`">
                    <div class="catalog-labs-slider__buttons" v-if="userLabs.length > 1" v-show="isShowElement">
                        <button
                            ref="prevBtn"
                            type="button"
                            :disabled="prevDisabled"
                            class="slider-nav-btn slider-nav-btn--dark slider-nav-btn--small slider-nav-btn--prev js-lab-prev-slide"
                        >Предыдущий слайд
                        </button>
                        <button
                            ref="nextBtn"
                            type="button"
                            :disabled="nextDisabled"
                            class="slider-nav-btn slider-nav-btn--dark slider-nav-btn--small js-lab-next-slide"
                        >Следующий слайд
                        </button>
                    </div>

                    <div class="catalog-labs-slider__items">
                        <div ref="slider" class="swiper-container">
                            <div class="swiper-wrapper">
                                <div
                                    v-for="(lab, index) in userLabs"
                                    :key="lab.ID"
                                    class="catalog-labs-slider__slide swiper-slide"
                                    :data-filter-query="lab.LAB_FILTER_COFFEE_QUERY"
                                    :data-brew-value="lab.LAB_FILTER_COFFEE.brew || null"
                                    :data-slider-index="index"
                                >
                                    <lab-card
                                        renderless
                                        :lab="lab"
                                        :equipments="getEquipments(lab.UF_COOKING_TYPE.ID)"
                                        :for-who="getForWho(lab.UF_FOR.ID)"
                                    >
                                        <template #default="{ labName, labPlace, rating , equipmentSlots, getEquipmentRating, checkEquipment }">
                                            <div :class="`lab-slide ${ index === currentSlideIndex ? '' : 'lab-slide--inactive'} ${ userLabs.length === 1 ? 'lab-slide--single' : ''} ${ !labFilterActive ? 'lab-slide--disabled' : ''}`">
                                                <div class="lab-slide__header">

                                                    <h4 class="lab-slide__name">
                                                        <span class="lab-slide__name-main">{{ labName }}</span> <span class="lab-slide__name-separate">/</span> <span class="lab-slide__name-type" v-if="isShowElement">Кофе-лаборатория</span>
                                                    </h4>

                                                    <div class="lab-slide__tag">
                                                        <span class="lab-tag">{{ labPlace }}</span>
                                                    </div>

                                                    <div class="lab-slide__rating" v-if="isShowElement">
                                                        <rating-stars :rating="rating"></rating-stars>
                                                    </div>

                                                    <div class="lab-slide__tune">
                                                        <a :href="`${recommendLink}#profile-recomm`" class="btn btn-block btn-main btn-sm">Улучшить</a>
                                                    </div>

                                                    <svg
                                                        class="lab-slide__chevron-adaptive"
                                                        :class="{'lab-slide__chevron-adaptive--open': isOpen}"
                                                        @click="toggleAdaptiveSpoiler"
                                                    >
                                                        <use xlink:href="/sprite.svg#icon-chevron-collapse"></use>
                                                    </svg>
                                                </div>

                                                <div class="lab-slide__equipment">
                                                    <div
                                                        class="lab-slide-card lab-slide__card"
                                                        v-for="equipment in equipmentSlots"
                                                        :key="equipment.ID"
                                                    >
                                                        <lab-card-equipment
                                                            :for-who-id="lab.UF_FOR.ID"
                                                            :cooking-type-id="lab.UF_COOKING_TYPE.ID"
                                                            :equipment-slot="equipment"
                                                            :equipment-selected="checkEquipment(equipment)"
                                                            modifier="filter"
                                                        />
                                                    </div>
                                                </div>

                                                <div class="lab-slide__handlers-adaptive" v-if="isShowElement">
                                                    <div class="lab-slide__tune">
                                                        <a :href="`${recommendLink}#profile-recomm`" class="btn btn-block btn-main btn-sm">Улучшить лабораторию</a>
                                                    </div>
                                                </div>

                                                <transition name="lab-slide-note">
                                                    <div class="lab-slide__note">
                                                        <template v-if="!catalogLoading">
                                                            <template  v-if="labFilterActive">
                                                                <p>Сейчас вы видите кофе, идеально подходящий для этой кофе-лаборатории</p>
                                                                <button @click.prevent="resetFilter" type="button" aria-label="Сбросить фильтр" class="lab-slide__reset">
                                                                    <svg width="24" height="24"><use xlink:href="/sprite.svg#icon-close-nofill"></use></svg>
                                                                    <span>Сбросить фильтр</span>
                                                                </button>
                                                            </template>
                                                            <template  v-else-if="filterIsClean || !labFilterActive">
                                                                <p>Сейчас вы видите кофе, без фильтрации</p>
                                                                <button @click.prevent="handleFilterForCurrentSlide" type="button" aria-label="Сбросить фильтр" class="lab-slide__reset">
                                                                    <span>Подобрать кофе для лаборатории</span>
                                                                </button>
                                                            </template>
                                                            <template  v-else>
                                                                <p>Сейчас вы видите кофе, подобранный в соответствии с фильтром</p>
                                                                <button @click.prevent="resetFilter" type="button" aria-label="Сбросить фильтр" class="lab-slide__reset">
                                                                    <span>Сбросить фильтр</span>
                                                                </button>
                                                            </template>
                                                        </template>
                                                        <template v-else>
                                                            <p>Пожалуйста, подождите...</p>
                                                        </template>
                                                    </div>
                                                </transition>
                                            </div>
                                        </template>
                                    </lab-card>
                                </div>
                            </div>
                            <div ref="pagination" class="swiper-pagination"></div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </labs-list>
</template>

<script>
import Swiper, { Pagination, Navigation } from 'swiper';
import {
    EVENT_APPLY_FILTER_STRING,
    EVENT_RESET_FILTER,
    FIND_LAB_BY_BREW,
} from '../../constants';

import LabCard from '../labs/lab-card';
import LabsList from '../labs/labs-list';
import LabCardEquipment from '../labs/lab-card-equipment';
import { useUrlSearchParams } from '../../vue-hooks/url-serch';
// import { queriesIsEqual } from '../../services/location-service';
import {
    EVENT_FINISH_LOAD_CATALOG,
    EVENT_START_LOAD_CATALOG,
    EVENT_LAB_SLIDER_INIT,
} from '../../services/event-bus/event-types';

Swiper.use([Pagination, Navigation]);

const { eventBus } = window.specialtyApp;

export default {
    name: 'lab-catalog-slider',

    components: {
        LabCard,
        LabCardEquipment,
        LabsList,
    },

    data() {
        const searchParams = useUrlSearchParams(this);
        const currentSlideIndex = this.calculateInitialSlideIndex(searchParams) || 0;
        return {
            searchParams,

            currentSlideIndex,
            currentSlideFilterParams: null,
            catalogLoading: false,

            isOpen: false,
        };
    },

    methods: {
        calculateInitialSlideIndex(searchParams) {
            // const currentIndex = this.$attrs.labs.findIndex((lab) => queriesIsEqual(searchParams.string, `?${lab.LAB_FILTER_COFFEE_QUERY}`));
            const currentIndex = this.$attrs.labs.findIndex((lab) => searchParams.obj.lab === lab.ID);

            return currentIndex === -1 ? 0 : currentIndex;
        },

        initSwiper() {
            const container = this.$refs.slider;

            if (Object.keys(this.$attrs.labs).length === 1) {
                return;
            }

            if (container) {
                const swiperInstance = new Swiper(container, {
                    loop: false,
                    initialSlide: this.currentSlideIndex,
                    effect: 'fade',
                    spaceBetween: 36,
                    calculateHeight: true,
                    navigation: {
                        nextEl: this.$refs.nextBtn,
                        prevEl: this.$refs.prevBtn,
                    },
                    pagination: {
                        el: this.$refs.pagination,
                        clickable: true,
                    },
                });

                swiperInstance.on('slideChangeTransitionEnd', (swiper) => {
                    this.currentSlideIndex = swiper.realIndex;
                });
                $(container).data('swiperInstance', swiperInstance);
            }
        },

        initBusEventHandling() {
            eventBus.$on(FIND_LAB_BY_BREW, (payload) => {
                this.handleFilterRequest(payload);
            });

            eventBus.$on(EVENT_START_LOAD_CATALOG, () => {
                this.catalogLoading = true;
            });

            eventBus.$on(EVENT_FINISH_LOAD_CATALOG, () => {
                this.catalogLoading = false;
            });
        },

        /**
         * Ищем первый слайдер с совпадением id метода заваривания
         * Если такой есть, то эмитим строку запроса для переключения фильтра
         * В противном случае, возвращем тот запрос, что пришёл из класса
         *
         * @param {String} brewValue - id метода заваривания
         * @param {String} requestString - строка запроса из value метода заваривания
         *
         */
        handleFilterRequest({ brewValue, requestString }) {
            if (!brewValue || !requestString) {
                eventBus.$emit(EVENT_APPLY_FILTER_STRING, '');
                return;
            }

            const currentLab = this.labsArr.find((lab) => +lab?.LAB_FILTER_COFFEE?.brew === +brewValue);
            const labQuery = currentLab ? currentLab.LAB_FILTER_COFFEE_QUERY : null;

            if (!labQuery) {
                this.brewValue = brewValue;
                eventBus.$emit(EVENT_APPLY_FILTER_STRING, requestString);
                return;
            }

            this.brewValue = brewValue;
            this.switchSlideByBrew();
            eventBus.$emit(EVENT_APPLY_FILTER_STRING, labQuery);
        },

        /**
         * Переключаем слайдер на слайд после успешной загрузки
         * Только в том случае, если запрос был через выбор в дропдауне "Метод заваривания"
         */
        switchSlideByBrew() {
            if (!this.brewValue) return;

            const slide = document.querySelector(`[data-brew-value="${this.brewValue}"]`);
            const slideIndex = slide.dataset.sliderIndex;

            const { swiper } = this.$refs.slider;

            if (swiper) {
                setTimeout(() => swiper.slideTo(slideIndex), 0);
            }
        },

        handleFilterForCurrentSlide() {
            this.brewValue = null;
            eventBus.$emit(this.currentSlideFilterParams ? EVENT_APPLY_FILTER_STRING : EVENT_RESET_FILTER, this.currentSlideFilterParams.substring(1));
        },

        resetFilter() {
            eventBus.$emit(EVENT_RESET_FILTER);
        },

        toggleAdaptiveSpoiler() {
            this.isOpen = !this.isOpen;
        },
    },

    computed: {
        labsArr() {
            return this.$attrs.labs;
        },

        labFilterActive() {
            const searchParams = new URLSearchParams(this.searchParams.string);
            const sliderSearchParams = new URLSearchParams(this.currentSlideFilterParams);

            return searchParams.get('lab') === sliderSearchParams.get('lab');
        },

        filterIsClean() {
            return Object.values(this.searchParams.obj).length === 0;
        },

        prevDisabled() {
            return this.currentSlideIndex === 0;
        },

        nextDisabled() {
            return this.currentSlideIndex + 1 === this.labsArr.length;
        },

        isMobile() {
            return window.innerWidth <= 576;
        },

        /**
         * Показывать или нет тот или иной элемент
         * Используется для псевдоспойлера на адаптиве
         *
         * @returns {boolean}
         */
        isShowElement() {
            let show;

            if (!this.isMobile) {
                show = true;
            } else {
                show = this.isOpen;
            }

            return show;
        },

        recommendLink() {
            return '/personal/labs/';
        },
    },

    watch: {
        currentSlideIndex: {
            immediate: true,
            handler(index) {
                const lab = this.labsArr[index];
                if (!lab) return;
                this.currentSlideFilterParams = `?${lab.LAB_FILTER_COFFEE_QUERY}`;
            },
        },

        currentSlideFilterParams: {
            handler() {
                this.handleFilterForCurrentSlide();
            },
        },
    },

    beforeMount() {
        this.initBusEventHandling();
    },

    mounted() {
        this.initSwiper();
        setTimeout(() => eventBus.$emit(EVENT_LAB_SLIDER_INIT), 0);
    },
};
</script>
